import React from 'react';
import logoShop from '../../images/logo-utees-shop.svg';
import DesignPreview from '../DesignPreview/DesignPreview';
import './ModalPageThree.css';

function ModalPageThree(props) {
  // Use the preview URL passed from the parent component
  const previewUrl = props.previewUrl;
  const artworkDisplayUrls = props.artworkDisplayUrls || [];

  // Merge uploaded artwork with display URLs from the server
  const uploadedArtwork = (props.formData.uploadedArtwork || []).map(function(artwork) {
    var matchingUrl = artworkDisplayUrls.find(function(u) { return u.s3_key === artwork.s3_key; });
    if (matchingUrl && matchingUrl.display_url) {
      return Object.assign({}, artwork, { display_url: matchingUrl.display_url });
    }
    return artwork;
  });

  // Determine if we have visual content to show
  const hasDesignContent = props.formData.product || props.formData.design || props.formData.designCustomization;
  const hasUploadedArtwork = uploadedArtwork.length > 0;
  const hasVisualContent = hasDesignContent || hasUploadedArtwork;

  const formatDate = dateString => {
    if (!dateString) return 'Not specified';
    // Parse the date string and add time to avoid timezone issues
    // If the date string is just YYYY-MM-DD, append time to treat as local
    const localDateString = dateString.includes('T')
      ? dateString
      : `${dateString}T00:00:00`;
    const date = new Date(localDateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const titleize = str => {
    if (!str) return str;
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const getFileExtension = filename => {
    return filename.split('.').pop().toLowerCase();
  };

  const formatFileSize = bytes => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const isPreviewableImage = file => {
    const ext = getFileExtension(file.filename);
    return ['png', 'jpg', 'jpeg', 'svg'].includes(ext);
  };

  const getImageIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <text x="6" y="17" fontSize="6" fill="currentColor" stroke="none" fontWeight="bold">IMG</text>
      </svg>
    );
  };

  const getFileTypeIcon = filename => {
    const ext = getFileExtension(filename);
    switch (ext) {
      case 'pdf':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <text x="8" y="17" fontSize="6" fill="currentColor" stroke="none" fontWeight="bold">PDF</text>
          </svg>
        );
      case 'ai':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <text x="9" y="17" fontSize="6" fill="currentColor" stroke="none" fontWeight="bold">AI</text>
          </svg>
        );
      case 'eps':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <text x="7" y="17" fontSize="6" fill="currentColor" stroke="none" fontWeight="bold">EPS</text>
          </svg>
        );
      default:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
          </svg>
        );
    }
  };

  const copyToClipboard = () => {
    if (previewUrl) {
      navigator.clipboard
        .writeText(previewUrl)
        .then(() => {
          alert('Preview link copied to clipboard!');
        })
        .catch(err => {
          console.error('Failed to copy:', err);
        });
    }
  };
  return (
    <section className="stack stack--large centered stretch phm" id="step-4">
      <div className="stack">
        <h1 className="heading-base heading-large heading-heavy heading-cofo">
          Thank you!
        </h1>
        <p className="medium medium--res">
          {props.formData.isStudent ? (
            <em>
              We are matching you with a{' '}
              <span className="tooltip-item">
                <span className="underline">Campus Manager™</span>{' '}
                <span className="tooltip tooltip--top tooltip--large tooltip--blue">
                  Our Campus Managers™ are experienced order facilitators who
                  help bring your ideas to life!
                </span>
              </span>{' '}
              and they will be reaching out to you soon.
            </em>
          ) : (
            <em>
              We are matching you with an Account Executive and they will be
              reaching out to you soon.
            </em>
          )}
        </p>

        {/* Preview Link Section - Moved to top and de-emphasized */}
        {previewUrl && (
          <div className="preview-link-section-top">
            <p className="small centered mbn">
              {props.formData.designCustomization
                ? 'Share your design with others!'
                : 'Share your quote details with others!'}
            </p>
            <div className="mts">
              <div className="preview-link-box">
                <input
                  type="text"
                  value={previewUrl}
                  readOnly
                  className="preview-link-input"
                  onClick={e => e.target.select()}
                />
                <button
                  className="button button--small"
                  onClick={copyToClipboard}
                >
                  Copy Link
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Two Column Layout - Design Preview and Order Details */}
        <div className={hasVisualContent ? 'modal-page-three-columns' : 'modal-page-three-columns modal-page-three-columns--single'}>
          {/* Left Column - Design Preview or Uploaded Artwork (only if we have content) */}
          {hasVisualContent && (
            <div className="modal-page-three-left">
              {hasDesignContent ? (
                <DesignPreview
                  designData={{
                    product: props.formData.product,
                    product_color: props.formData.productColor,
                    design: props.formData.design,
                    design_customization: props.formData.designCustomization,
                  }}
                  hideCustomerDetails={true}
                />
              ) : (
                <div className="uploaded-artwork-confirmation">
                  <h4 className="uploaded-artwork-title">Your Uploaded Artwork</h4>
                  <p className="uploaded-artwork-subtitle">
                    {uploadedArtwork.length} file{uploadedArtwork.length !== 1 ? 's' : ''} submitted
                  </p>
                  <div className="uploaded-artwork-list">
                    {uploadedArtwork.map((file, index) => (
                      <div key={file.s3_key || index} className="uploaded-artwork-item">
                        <div className="uploaded-artwork-item-preview">
                          {file.display_url && isPreviewableImage(file) ? (
                            <img
                              src={file.display_url}
                              alt={file.filename}
                              className="uploaded-artwork-item-thumbnail"
                            />
                          ) : (
                            <div className="uploaded-artwork-item-icon">
                              {isPreviewableImage(file) ? getImageIcon() : getFileTypeIcon(file.filename)}
                            </div>
                          )}
                        </div>
                        <div className="uploaded-artwork-item-info">
                          <span className="uploaded-artwork-item-name">{file.filename}</span>
                          <span className="uploaded-artwork-item-size">{formatFileSize(file.size)}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <p className="uploaded-artwork-note">
                    Your artwork has been securely uploaded and will be reviewed by our team.
                  </p>
                </div>
              )}
            </div>
          )}

          {/* Right Column - Customer & Order Details */}
          <div className="modal-page-three-right">
            <div className="order-details-box">
              {/* Customer Information */}
              <div className="detail-section">
                <h4 className="detail-section-title">Customer Information</h4>
                <div className="detail-row">
                  <span className="detail-label">Name:</span>
                  <span className="detail-value">{props.formData.name}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">{props.formData.email}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Phone:</span>
                  <span className="detail-value">
                    {props.formData.phoneNumber}
                  </span>
                </div>
                {props.formData.isStudent && (
                  <div className="detail-row">
                    <span className="detail-label">School:</span>
                    <span className="detail-value">
                      {props.formData.school}
                    </span>
                  </div>
                )}
                {props.formData.isStudent && props.formData.organization && (
                  <div className="detail-row">
                    <span className="detail-label">Organization:</span>
                    <span className="detail-value">
                      {props.formData.organization}
                    </span>
                  </div>
                )}
                {!props.formData.isStudent && (
                  <div className="detail-row">
                    <span className="detail-label">Business:</span>
                    <span className="detail-value">
                      {props.formData.businessName || 'N/A'}
                    </span>
                  </div>
                )}
                {props.formData.eventName && (
                  <div className="detail-row">
                    <span className="detail-label">Event:</span>
                    <span className="detail-value">
                      {props.formData.eventName}
                    </span>
                  </div>
                )}
                {props.formData.orderNotes && (
                  <div className="detail-row">
                    <span className="detail-label">Notes:</span>
                    <span className="detail-value">
                      {props.formData.orderNotes}
                    </span>
                  </div>
                )}
              </div>

              {/* Order Information */}
              <div className="detail-section">
                <h4 className="detail-section-title">Order Information</h4>
                {props.formData.product && (
                  <>
                    <div className="detail-row">
                      <span className="detail-label">Product:</span>
                      <span className="detail-value">
                        {props.formData.product.brandName}{' '}
                        {props.formData.product.style}{' '}
                        {props.formData.product.name}
                      </span>
                    </div>
                    {props.formData.productColor &&
                      props.formData.productColor.name !== 'Default' && (
                        <div className="detail-row">
                          <span className="detail-label">Color:</span>
                          <span className="detail-value">
                            {titleize(props.formData.productColor.name)}
                          </span>
                        </div>
                      )}
                  </>
                )}
                <div className="detail-row">
                  <span className="detail-label">Quantity:</span>
                  <span className="detail-value">
                    {props.formData.quantity || '-'}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Budget:</span>
                  <span className="detail-value">
                    {props.formData.budget ? `$${props.formData.budget}` : '-'}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Delivery Date:</span>
                  <span className="detail-value">
                    {formatDate(props.formData.deliveryDate) || 'Not specified'}
                  </span>
                </div>
                {props.formData.designNotes && (
                  <div className="detail-row">
                    <span className="detail-label">Design Notes:</span>
                    <span className="detail-value">
                      {props.formData.designNotes}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="capped row row-centered2">
          <div className="col-6--m">
            <p className="phs">
              <small>
                Shop single-piece apparel for your organization on the
              </small>
            </p>
            <h2>
              <img src={logoShop} alt="Logo for the University Tees Shop" />
              <span className="is-hidden-visually">University Tees Shop</span>
            </h2>
            <a
              href="https://shop.universitytees.com"
              className="button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Shop Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ModalPageThree;
